export * from './FAQAdapter';
export * from './FAQTypeListAdapter';
